import React from "react";
import HeaderTwo from "../../components/header/headerTwo";

const Program = () => {
  return (
    <div className="max-w-[650px] mx-auto px-4">
      <HeaderTwo />
      <div className="px-4 py-4 border border-gray-400 rounded-lg mt-4 mb-4">
        <div className="flex gap-2 items-center mt-4">
          <div className="px-2  border bg-[#A31D1D] text-white rounded-full">3</div>

          <h1 className="text-[#A31D1D] text-start font-bold text-xl">Program</h1>
        </div>

        <div className="mt-3">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime quos tenetur repudiandae rerum culpa sequi repellendus sit doloremque pariatur facilis nihil sunt quaerat, est asperiores quia exercitationem. Alias accusamus sequi
          cum soluta maxime? Voluptas nesciunt quidem, numquam eligendi voluptatibus sunt porro, temporibus velit excepturi maxime a officiis. Explicabo veritatis, minima possimus eos debitis magni! Placeat vero saepe fugiat maiores iste
          aut perspiciatis molestias, dolores tempore ullam provident sint minus assumenda. Ad, eos quisquam provident deserunt veniam ipsam reiciendis ipsum temporibus architecto voluptate cumque similique harum sapiente dolores rerum sed
          consequuntur perspiciatis assumenda nesciunt recusandae earum molestiae eius ducimus praesentium? Quod?
        </div>
      </div>
    </div>
  );
};

export default Program;
